import { render, staticRenderFns } from "./dataCleaningSubtable.vue?vue&type=template&id=4e7ffe40&scoped=true&"
import script from "./dataCleaningSubtable.vue?vue&type=script&lang=js&"
export * from "./dataCleaningSubtable.vue?vue&type=script&lang=js&"
import style0 from "./dataCleaningSubtable.vue?vue&type=style&index=0&id=4e7ffe40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7ffe40",
  null
  
)

export default component.exports